import { clientSingleton, type Client } from '@edge/spark/io-apollo'
import { useCurrentAuthenticatedUser } from '@edge/spark/io-aws'
import { useCurrentUserQuery, CurrentUserDocument, type CurrentUserQuery } from '../generated/graphql'
import { pickUserAttributes } from '../utils/pickUserAttributes'

/** Returns spark attributes for the current user */
export const useCurrentUserAttributes = () => {
    /** Should rerun if auth status changes */
    useCurrentAuthenticatedUser()

    const { data } = useCurrentUserQuery()

    return pickUserAttributes(data?.user?.attributes)
}

interface GetCurrentUserAttributesProps {
    /** ApolloClient. Attempts to use client singleton if not passed */
    client?: Client
}

/** Uses passed Client or clientSingleton. Gets current user's spark attributes */
export const getCurrentUserAttributes = async (props?: GetCurrentUserAttributesProps) => {
    const client = props?.client || clientSingleton

    const { data } = await client.query<CurrentUserQuery>({ query: CurrentUserDocument, fetchPolicy: 'network-only' })
    return pickUserAttributes(data?.user?.attributes)
}
